import React, { useId } from 'react';
import styled from 'styled-components';
import useProperty from '../../hooks/useProperty';
import usePropertyPath from '../../hooks/usePropertyPath';
import useDataSource from '../../hooks/useDataSource';
import { DoubleFieldGrid } from 'styles/v2/Styles.styled';
import WizardSelectControlledComponent from 'components/v2/epd-wizard-inputs/WizardSelectControlled';
import { TextButton } from 'components/v2/buttons';
import FontIcon from 'components/icons/FontIcon';
import WizardCheckboxComponent from 'components/v2/epd-wizard-inputs/WizardCheckbox';

interface Props {
  canBeDeleted: boolean;
  onDelete(): void;
  onMakeMain(value: string): void;
}

const LcaDatabasesListRendererEntry: React.FC<Props> = ({ canBeDeleted, onDelete, onMakeMain }) => {
  const databaseIdPath = usePropertyPath('id');
  const databaseId = useProperty<string | null>(databaseIdPath);
  const databaseIdOptions = useDataSource(databaseIdPath).options;

  const versionIdPath = usePropertyPath('versionId');
  const versionId = useProperty<string | null>(versionIdPath);
  const versionIdOptions = useDataSource(versionIdPath).options;

  const isMainPath = usePropertyPath('isMain');
  const isMain = useProperty<string | null>(isMainPath);
  const isMainId = useId();

  return (
    <div>
      <DoubleFieldGrid>
        <WizardSelectControlledComponent
          name="id"
          options={databaseIdOptions}
          value={databaseIdOptions.find((o) => o.value === databaseId.value) ?? null}
          label="Database"
          onChanged={(_: string, newValue: any) => databaseId.setValue(newValue)}
          error={databaseId.errorMessage}
          disabled={databaseId.isDisabled}
        />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '0.5rem' }}>
          <WizardSelectControlledComponent
            name="versionId"
            options={versionIdOptions}
            value={versionIdOptions.find((o) => o.value === versionId.value) ?? null}
            label="Version"
            onChanged={(_: string, newValue: any) => versionId.setValue(newValue)}
            error={versionId.errorMessage}
            disabled={versionId.isDisabled}
          />
          {!versionId.isDisabled && canBeDeleted && (
            <TextButton
              style={{ alignSelf: 'flex-end', margin: '0.25rem' }}
              type="button"
              text
              icon={<FontIcon icon="delete" />}
              onClick={onDelete}
            />
          )}
        </div>
      </DoubleFieldGrid>

      <CheckBoxGroup>
        <WizardCheckboxComponent
          inputId={isMainId}
          label="Set as main database"
          name="isMain"
          value={isMain.value === 'Yes'}
          onChanged={(_: string, value: any) => onMakeMain(value ? 'Yes' : 'No')}
          disabled={isMain.isDisabled}
          size="small"
        />
      </CheckBoxGroup>
    </div>
  );
};

export default LcaDatabasesListRendererEntry;

const CheckBoxGroup = styled.div`
  text-align: start;
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-radius: 2px;
`;
